import React, { useState } from 'react'
import '../App.css'
import axios from 'axios'
import { SERVER_URI } from '../utility/config'
import LoginRequest from './LoginRequest'

function RejectReasonCreatedMessage(props) {
  window.setTimeout(function () {
    // Move to a new location
    props.handleClose()
  }, 1700)
  return (
    <div>
      <h2 className='message_title'>Oletussyy hylkäykselle asetettu</h2>
    </div>
  )
}

function AddDefaultRejectReason(props) {
  const [show, setShow] = useState(false)
  const [userData, setUserData] = useState({
    rejectMessage: props.defaultReason.rejectMessage,
  })
  let storage = window.localStorage
  let userToken = storage.getItem('admin_token')

  //Look at this closer
  const onChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value })
  }

  // Submit
  const doSubmit = async (e) => {
    e.preventDefault()
    try {
      await axios.post(`${SERVER_URI}/set_default_reject_message/`, userData, {
        headers: { Authorization: `Token ${userToken}` },
      })
      props.dispatch({
        type: 'UPDATE_DEFAULT_REJECT_REASON',
        data: { newReason: userData },
      })
      setShow(!show)
    } catch (e) {
      console.log('Error in setting default reason for rejection', e)
    }
  }
  return (
    <div className='popUp_card'>
      <div className='popup-box'>
        <div className='box'>
          <span className='close-icon' onClick={props.handleClose}>
            x
          </span>
          {!show && (
            <div>
              <h2 className='popUp_title'>Aseta oletussyy hylkäämiselle </h2>
              <form
                className='rejectionReason_form'
                onSubmit={(e) => doSubmit(e)}
              >
                <label className='label_add' htmlFor='rejectReason'>
                  Oletussyy hylkäämiselle:
                </label>
                <br />
                <textarea
                  id='rejectReason'
                  name='rejectMessage'
                  onChange={onChange}
                  rows='4'
                  cols='50'
                  value={userData.rejectMessage}
                  required
                ></textarea>{' '}
                <br className='desktop-break' />
                <input
                  type='submit'
                  id='gradient_Button'
                  value='Aseta oletussyy hylkäämiselle'
                />
              </form>
            </div>
          )}
          {show && (
            <RejectReasonCreatedMessage handleClose={props.handleClose} />
          )}
        </div>
      </div>
    </div>
  )
}

function DefaultRejectReason(props) {
  props.stopListRefresh()
  const [isOpen, setIsOpen] = useState(false)
  //const [isloggedIn, setIsloggedIn] = useState(true);
  //let storage = window.localStorage;
  //let userToken = storage.getItem("admin_token")

  /*  useEffect(() => {
        const fetchLogin = async () => {
            if (userToken === null) {
                console.log("kirjaudu sisään")
                setIsloggedIn(false)
            }
        }
        fetchLogin();
        // DON'T DELETE THE COMMENT BELOW!!
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) */

  const togglePopUp = async () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className='configurations'>
      {isOpen && (
        <AddDefaultRejectReason
          defaultReason={props.defaultReason}
          dispatch={props.dispatch}
          handleClose={togglePopUp}
        />
      )}
      <h3>
        Oletussyy tilauksen
        <br /> hylkäämiselle
      </h3>
      <div className='RejectReason'>
        <div className='reason_list'>
          {props.defaultReason === undefined ? (
            <LoginRequest />
          ) : (
            props.defaultReason.rejectMessage
          )}{' '}
          <br />
        </div>
      </div>
      <button id='gradient_Button' onClick={togglePopUp}>
        Aseta oletussyy hylkäykselle
      </button>
    </div>
  )
}

export default DefaultRejectReason
